import React, { useEffect } from "react";
import { IJiraIssue } from "../../common/interface";
import { useAttachmentContext } from "../../context/AttachmentContext";
import { ADFRenderer } from "../ADFRenderer";
import FilePreviewDialog from "../FilePreviewDialog";
import "./style.scss";

interface IJiraIssueDescriptionProps {
  issueData: IJiraIssue;
  containerRef: React.RefObject<HTMLDivElement>;
}

const JiraIssueDescriptionRenderer: React.FC<IJiraIssueDescriptionProps> = ({
  issueData,
  containerRef,
}) => {
  const {
    setAttachments,
    setRenderedFields,
    viewAttachmentIndex,
    setViewAttachmentIndex,
  } = useAttachmentContext();

  const adfDocument = issueData?.fields?.description;
  const renderedFields = issueData?.renderedFields;
  const attachment = issueData?.fields?.attachment;

  useEffect(() => {
    setAttachments(attachment ?? []);
    setRenderedFields(renderedFields ?? null);
  }, [attachment, setAttachments, renderedFields, setRenderedFields]);

  if (!adfDocument) {
    return <p>No description available.</p>;
  }

  const onClose = () => {
    setViewAttachmentIndex(null);
  };

  return (
    <div className="jira-adfDocument-container">
      {viewAttachmentIndex && viewAttachmentIndex >= 0 && (
        <FilePreviewDialog
          open={viewAttachmentIndex >= 0}
          onClose={onClose}
          attachmentIndex={viewAttachmentIndex}
          fullscreenContainer={containerRef.current}
        />
      )}
      <ADFRenderer content={adfDocument?.content} />
    </div>
  );
};

export default JiraIssueDescriptionRenderer;
